
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns8362a3c6680fcbbf3d1f18911ab6efc2en from './en.yaml'
            i18n.addResourceBundle('en', '8362a3c6680fcbbf3d1f18911ab6efc2', flattenObject(ns8362a3c6680fcbbf3d1f18911ab6efc2en), true, true);
        
        export default '8362a3c6680fcbbf3d1f18911ab6efc2';
    